// extracted by mini-css-extract-plugin
module.exports = {"FullPowerTrigger":"FullPowerTrigger_FullPowerTrigger__Ws4Ob"};